import React from "react"

export function AsideMenuAccount({ layoutProps }) {
  return (
    <>
      <ul className={`menu-nav ${layoutProps.ulClasses}`}></ul>
    </>
  )
}
